var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg_({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "143.89453pt",
    height: "359.17188pt",
    viewBox: "0 0 143.89453 359.17187",
    id: "svg605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.21875,2.71875 c -0.074219,0.175781 -0.25,0.265625 -0.53125,0.265625 -0.085938,0 -0.167969,-0.011719 -0.25,-0.03125 L 1.03125,2.84375 C 0.570312,2.71875 0.265625,2.472656 0.109375,2.109375 0.0351562,1.929688 0,1.726562 0,1.5 V 0.703125 c 0,-0.148437 0.0664062,-0.21875 0.203125,-0.21875 0.132813,0 0.203125,0.070313 0.203125,0.21875 v 0.90625 c 0,0.175781 0.054688,0.34375 0.171875,0.5 0.125,0.15625 0.273437,0.253906 0.453125,0.296875 L 1.4375,2.515625 C 1.53125,2.546875 1.609375,2.5625 1.671875,2.5625 1.929688,2.5625 2.0625,2.390625 2.0625,2.046875 v -0.375 c 0,-0.136719 0.066406,-0.203125 0.203125,-0.203125 0.132813,0 0.203125,0.066406 0.203125,0.203125 V 2.15625 c 0,0.25 0.101562,0.460938 0.3125,0.640625 0.09375,0.082031 0.195312,0.140625 0.3125,0.171875 0.070312,0.00781 0.132812,0.015625 0.1875,0.015625 0.289062,0 0.4375,-0.167969 0.4375,-0.5 V 1.6875 c 0,-0.136719 0.066406,-0.203125 0.203125,-0.203125 0.132813,0 0.203125,0.066406 0.203125,0.203125 V 2.609375 C 4.125,2.921875 3.976562,3.15625 3.6875,3.3125 3.5625,3.382812 3.429688,3.421875 3.296875,3.421875 3.222656,3.421875 3.15625,3.410156 3.09375,3.390625 2.644531,3.273438 2.351562,3.050781 2.21875,2.71875 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.40625,1.59375 c 0,0.425781 0.207031,0.695312 0.625,0.8125 L 1.4375,2.515625 C 1.519531,2.546875 1.597656,2.5625 1.671875,2.5625 1.929688,2.5625 2.0625,2.390625 2.0625,2.046875 V 1.40625 L 1.03125,1.125 C 0.96875,1.113281 0.914062,1.109375 0.875,1.109375 0.738281,1.109375 0.625,1.15625 0.53125,1.25 0.445312,1.34375 0.40625,1.457031 0.40625,1.59375 Z M 0,1.484375 C 0,1.191406 0.148438,0.960938 0.453125,0.796875 0.585938,0.722656 0.722656,0.6875 0.859375,0.6875 c 0.050781,0 0.109375,0.003906 0.171875,0.015625 L 2.265625,1.03125 c 0.457031,0.125 0.84375,0.332031 1.15625,0.625 C 3.765625,1.976562 4,2.398438 4.125,2.921875 c 0,0.00781 0,0.023437 0,0.046875 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 3.804688,3.171875 3.738281,3.125 3.71875,3.03125 3.6875,2.800781 3.601562,2.570312 3.46875,2.34375 3.207031,1.925781 2.875,1.660156 2.46875,1.546875 V 2.15625 C 2.46875,2.394531 2.394531,2.59375 2.25,2.75 2.101562,2.90625 1.910156,2.984375 1.671875,2.984375 1.585938,2.984375 1.507812,2.972656 1.4375,2.953125 L 1.03125,2.84375 C 0.550781,2.707031 0.242188,2.472656 0.109375,2.140625 0.0351562,1.960938 0,1.742188 0,1.484375 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.03125,2.921875 0.09375,1.71875 C 0.03125,1.6875 0,1.628906 0,1.546875 0,1.492188 0.0195312,1.445312 0.0625,1.40625 0.101562,1.363281 0.15625,1.34375 0.21875,1.34375 l 3.703125,0.140625 c 0.132813,0 0.203125,0.066406 0.203125,0.203125 0,0.144531 -0.074219,0.21875 -0.21875,0.21875 l -2.9375,-0.125 1.8125,1.109375 c 0.070312,0.039063 0.109375,0.097656 0.109375,0.171875 0,0.132812 -0.0625,0.207031 -0.1875,0.21875 l -1.75,0.125 3.0625,1.515625 C 4.085938,4.960938 4.125,5.023438 4.125,5.109375 4.125,5.242188 4.054688,5.3125 3.921875,5.3125 c -0.03125,0 -0.0625,-0.00781 -0.09375,-0.015625 L 0.109375,3.453125 C 0.0351562,3.410156 0,3.347656 0,3.265625 0,3.128906 0.0625,3.0625 0.1875,3.0625 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.40625,2.40625 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 0.0664062,2.609375 0,2.539062 0,2.40625 V 0.640625 C 0,0.578125 0.0195312,0.53125 0.0625,0.5 0.101562,0.46875 0.148438,0.460938 0.203125,0.484375 L 3.96875,1.5 C 4.070312,1.519531 4.125,1.582031 4.125,1.6875 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 -0.023437,0 -0.042969,0 -0.0625,0 L 0.40625,0.96875 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.0625,2.53125 v -1.125 L 0.40625,0.96875 v 1.4375 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 0.0664062,2.609375 0,2.539062 0,2.40625 V 0.640625 C 0,0.578125 0.0195312,0.53125 0.0625,0.5 0.101562,0.46875 0.148438,0.460938 0.203125,0.484375 l 3.71875,1 C 4.054688,1.515625 4.125,1.601562 4.125,1.75 v 1.640625 c 0,0.144531 -0.070312,0.21875 -0.203125,0.21875 -0.136719,0 -0.203125,-0.074219 -0.203125,-0.21875 V 1.84375 l -1.25,-0.328125 V 2.53125 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 2.128906,2.734375 2.0625,2.664062 2.0625,2.53125 Z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.921875,1.484375 C 4.054688,1.515625 4.125,1.601562 4.125,1.75 v 1.28125 c 0,0.21875 -0.09375,0.40625 -0.28125,0.5625 -0.179688,0.164062 -0.375,0.25 -0.59375,0.25 -0.054688,0 -0.105469,-0.00781 -0.15625,-0.015625 l -2.0625,-0.5625 C 0.34375,3.078125 0,2.628906 0,1.921875 V 0.640625 C 0,0.578125 0.0195312,0.53125 0.0625,0.5 0.101562,0.46875 0.148438,0.460938 0.203125,0.484375 Z M 3.71875,1.84375 0.40625,0.96875 v 1.0625 c 0,0.175781 0.054688,0.34375 0.171875,0.5 0.125,0.15625 0.273437,0.257812 0.453125,0.3125 l 2.0625,0.546875 c 0.050781,0.019531 0.101562,0.03125 0.15625,0.03125 0.132812,0 0.242188,-0.054687 0.328125,-0.15625 0.09375,-0.09375 0.140625,-0.210937 0.140625,-0.34375 z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.6875,4.109375 H 0 V 0.25 c 0.175781,-0.011719 0.34375,0.015625 0.5,0.078125 0.257812,0.101563 0.515625,0.257813 0.765625,0.46875 0.257813,0.21875 0.554687,0.53125 0.890625,0.9375 0.519531,0.632813 0.929688,1.0625 1.234375,1.28125 0.300781,0.226563 0.585937,0.34375 0.859375,0.34375 0.289062,0 0.53125,-0.105469 0.71875,-0.3125 0.195312,-0.199219 0.296875,-0.460937 0.296875,-0.78125 0,-0.34375 -0.105469,-0.621094 -0.3125,-0.828125 C 4.742188,1.226562 4.457031,1.125 4.09375,1.125 l 0.078125,-0.75 c 0.550781,0.050781 0.96875,0.242188 1.25,0.578125 0.289063,0.332031 0.4375,0.773437 0.4375,1.328125 0,0.5625 -0.15625,1.003906 -0.46875,1.328125 -0.304687,0.320313 -0.6875,0.484375 -1.15625,0.484375 -0.230469,0 -0.460937,-0.046875 -0.6875,-0.140625 C 3.328125,3.859375 3.09375,3.695312 2.84375,3.46875 2.59375,3.25 2.25,2.882812 1.8125,2.375 1.445312,1.945312 1.203125,1.671875 1.078125,1.546875 0.953125,1.421875 0.820312,1.320312 0.6875,1.25 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.875,0.34375 c 0.695312,0 1.253906,0.066406 1.671875,0.203125 0.414063,0.144531 0.738281,0.359375 0.96875,0.640625 0.226563,0.28125 0.34375,0.628906 0.34375,1.046875 0,0.320313 -0.0625,0.597656 -0.1875,0.828125 C 5.546875,3.300781 5.363281,3.5 5.125,3.65625 4.882812,3.8125 4.59375,3.929688 4.25,4.015625 c -0.335938,0.082031 -0.792969,0.125 -1.375,0.125 -0.679688,0 -1.230469,-0.074219 -1.65625,-0.21875 C 0.800781,3.785156 0.476562,3.578125 0.25,3.296875 c -0.2304688,-0.273437 -0.34375,-0.625 -0.34375,-1.0625 0,-0.5625 0.195312,-1 0.59375,-1.3125 C 0.988281,0.535156 1.78125,0.34375 2.875,0.34375 Z m 0,0.734375 c -0.960938,0 -1.601562,0.109375 -1.921875,0.328125 -0.3125,0.226562 -0.46875,0.503906 -0.46875,0.828125 0,0.332031 0.160156,0.609375 0.484375,0.828125 0.320312,0.226562 0.957031,0.34375 1.90625,0.34375 0.96875,0 1.609375,-0.117188 1.921875,-0.34375 0.3125,-0.21875 0.46875,-0.496094 0.46875,-0.828125 0,-0.335937 -0.140625,-0.59375 -0.421875,-0.78125 -0.355469,-0.25 -1.011719,-0.375 -1.96875,-0.375 z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0.59375 H 5.84375 V 1.375 H 0.6875 V 4.25 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g606",
    transform: "translate(-217.37109,-434.57422)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,-0.00182567 h -33.4375 m -4.958333,0 h -4.963542 m -5.119792,0 h -4.958333 m -4.958333,0 h -24.802084 m -5.119791,0 h -4.958334 m -4.963541,0 h -4.958335 m -4.95833,0 h -24.96354 m -4.95834,0 h -4.95833 m -4.96354,0 h -4.95833",
    transform: "matrix(0.75,0,0,0.75,361.08,793.55996)",
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.52083,1058.0781 h -33.44271 v -27.5156",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,-0.00101233 V -5.120804 m 0,-4.958333 v -4.958334 m 0,-4.963541 v -24.958334 m 0,-4.958333 v -4.963542 m 0,-4.958333 v -4.958333 m 0,-4.963542 v -24.958333 m 0,-4.958334 v -4.963544 m 0,-4.95833 v -4.95833 m 0,-4.96355 v -24.95833 m 0,-4.95833 v -4.96354 m 0,-4.95834 v -5.11979 m 0,-4.95833 v -24.80209 m 0,-4.95833 v -4.96354 m 0,-5.11979 v -4.95834 m 0,-4.95833 v -24.80208 m 0,-5.11979 v -4.95834 m 0,-4.95833 v -4.96354 m 0,-4.95834 v -24.95833 m 0,-4.96354 v -4.95833 m 0,-4.95834 v -4.96354 m 0,-4.95833 v -24.95834 m 0,-4.96354 v -4.95833 m 0,-4.95833 v -4.96355 m 0,-5.11979 v -24.79687 m 0,-4.96354 v -4.95834 m 0,-5.11979 v -4.95833",
    transform: "matrix(0.75,0,0,0.75,217.55999,769.19998)",
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 290.07812,607.19792 V 579.6823 h 33.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,0.002304 H 4.957489 m 4.963542,0 h 4.958333 m 4.958333,0 h 24.963542 m 4.958333,0 h 4.958334 m 4.963541,0 h 4.958334 m 5.119791,0 h 24.802084 m 4.958333,0 h 4.958331 m 5.11979,0 h 4.96355",
    transform: "matrix(0.75,0,0,0.75,246.36001,434.75999)",
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 448,579.6823 h 33.4375 v 27.51562",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,0.00149067 V 4.959824 m 0,5.119792 v 4.958333 m 0,4.963542 v 24.796875 m 0,5.119791 v 4.963542 m 0,4.958333 v 4.958334 m 0,4.963541 v 24.958334 m 0,4.958333 v 4.963546 m 0,4.95833 v 4.95833 m 0,4.96354 v 24.95834 m 0,4.95833 v 4.96354 m 0,4.95834 v 4.95833 m 0,5.11979 v 24.80208 m 0,4.95834 v 4.95833 m 0,5.11979 v 4.96354 m 0,4.95834 v 24.80208 m 0,4.95833 v 5.1198 m 0,4.95833 v 4.96354 m 0,4.95833 v 24.95834 m 0,4.96354 v 4.95833 m 0,4.95834 v 4.96354 m 0,4.95833 v 24.95833 m 0,4.96355 v 4.95833 m 0,4.95833 v 4.96354 m 0,4.95834 v 24.95833 m 0,4.96354 v 4.95834 m 0,4.95833 v 5.11979",
    transform: "matrix(0.75,0,0,0.75,361.08,459.11998)",
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 481.4375,1030.5625 v 27.5156",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path279"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 361.07812,434.76172 -0.23828,10.55859 v -10.55859 z m 0,0",
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 361.07812,434.76172 v 10.55859 h -0.23828 z m 0,0",
    id: "path281"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.83984,445.19922 -1.55859,0.12109 v -0.12109 z m 0,0",
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.83984,445.19922 v 0.12109 h -1.55859 z m 0,0",
    id: "path283"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 359.28125,443.87891 -0.24219,1.4414 v -1.4414 z m 0,0",
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 359.28125,443.87891 v 1.4414 h -0.24219 z m 0,0",
    id: "path285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.76172,436.55859 -1.32031,0.1211 v -0.1211 z m 0,0",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.76172,436.55859 v 0.1211 h -1.32031 z m 0,0",
    id: "path287"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 360.83984,434.76172 352.44141,435 v -0.23828 z m 0,0",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 360.83984,434.76172 V 435 h -8.39843 z m 0,0",
    id: "path289"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 352.44141,434.76172 -0.24219,1.91797 v -1.91797 z m 0,0",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 352.44141,434.76172 v 1.91797 h -0.24219 z m 0,0",
    id: "path291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,0.002304 H 11.837494 M 0.321869,0.320012 H 11.519786 M 11.837494,0.002304 V 14.080429 M 11.519786,0.320012 v 13.598959 m 0.317708,0.161458 h -2.71875 m 2.401042,-0.161458 H 9.441661 m -0.322917,0.161458 v -1.921875 m 0.322917,1.760417 V 12.158554 M -0.00104767,0.002304 V 2.559596 M 0.321869,0.320012 V 2.398137 M -0.00104767,2.559596 H 2.082286",
    transform: "matrix(0.75,0,0,0.75,352.2,434.75999)",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.92187,582.07813 h 1.76042 v 0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-0.00148 H -0.321259 m -2.880208,-9.598958 v 0.958333 m 0,0.161458 v 0.958334 m 0,0.161458 v 0.958333 m 0,0.322917 v 0.958333 m 0,0.161459 v 0.958333 m 0,0.322917 v 0.796875",
    transform: "matrix(0.75,0,0,0.75,359.28001,443.88002)",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.83854,589.28125 v 0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-0.00148 H 0.958537 m 0.161458,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.161459,0 H 4.47937 m 0.161458,0 h 0.958334 m 0.322916,0 h 0.958334",
    transform: "matrix(0.75,0,0,0.75,353.16,443.88002)",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 477.92187,591.83855 h 0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path297"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.55859,434.76172 0.1211,10.55859 v -10.55859 z m 0,0",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.55859,434.76172 v 10.55859 h 0.1211 z m 0,0",
    id: "path299"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.67969,445.19922 1.67968,0.12109 v -0.12109 z m 0,0",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.67969,445.19922 v 0.12109 h 1.67968 z m 0,0",
    id: "path301"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 219.35937,443.87891 0.1211,1.4414 v -1.4414 z m 0,0",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 219.35937,443.87891 v 1.4414 h 0.1211 z m 0,0",
    id: "path303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.87891,436.55859 1.32031,0.1211 v -0.1211 z m 0,0",
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.87891,436.55859 v 0.1211 h 1.32031 z m 0,0",
    id: "path305"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 217.67969,434.76172 226.19922,435 v -0.23828 z m 0,0",
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 217.67969,434.76172 V 435 h 8.51953 z m 0,0",
    id: "path307"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 226.19922,434.76172 0.12109,1.91797 v -1.91797 z m 0,0",
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 226.19922,434.76172 v 1.91797 h 0.12109 z m 0,0",
    id: "path309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.002304 H -11.681885 m 11.520833,0.317708 h -11.359375 m -0.161458,-0.317708 v 14.078125 m 0.161458,-13.760417 v 13.598959 m -0.161458,0.161458 h 2.5625 m -2.401042,-0.161458 h 2.239584 m 0.161458,0.161458 v -1.921875 m -0.161458,1.760417 V 12.158554 M 4.06667e-4,0.002304 V 2.559596 M -0.161052,0.320012 V 2.398137 M 4.06667e-4,2.559596 H -1.921468",
    transform: "matrix(0.75,0,0,0.75,226.32001,434.75999)",
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.59896,582.07813 h -1.76042 v 0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00148 H 0.160614 m 2.880208,-9.598958 v 0.958333 m 0,0.161458 v 0.958334 m 0,0.161458 v 0.958333 m 0,0.322917 v 0.958333 m 0,0.161459 v 0.958333 m 0,0.322917 v 0.796875",
    transform: "matrix(0.75,0,0,0.75,219.36001,443.88002)",
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 295.52083,589.28125 v 0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00148 H -0.797719 m -0.322917,0 h -0.958333 m -0.161459,0 h -0.958333 m -0.161458,0 h -0.958334 m -0.322916,0 h -0.958334 m -0.161458,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,225.36001,443.88002)",
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.4375,591.83855 h -0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path315"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 361.07812,793.55859 360.83984,783 v 10.55859 z m 0,0",
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 361.07812,793.55859 V 783 h -0.23828 z m 0,0",
    id: "path317"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 360.83984,783.12109 359.28125,783 v 0.12109 z m 0,0",
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 360.83984,783.12109 V 783 h -1.55859 z m 0,0",
    id: "path319"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 359.28125,784.44141 359.03906,783 v 1.44141 z m 0,0",
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 359.28125,784.44141 V 783 h -0.24219 z m 0,0",
    id: "path321"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.76172,791.76172 -1.32031,-0.1211 v 0.1211 z m 0,0",
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.76172,791.76172 v -0.1211 h -1.32031 z m 0,0",
    id: "path323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.83984,793.55859 -8.39843,-0.23828 v 0.23828 z m 0,0",
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.83984,793.55859 v -0.23828 h -8.39843 z m 0,0",
    id: "path325"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 352.44141,793.55859 -0.24219,-1.91797 v 1.91797 z m 0,0",
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 352.44141,793.55859 v -1.91797 h -0.24219 z m 0,0",
    id: "path327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,-0.00182567 H 11.837494 M 0.321869,-0.319534 h 11.197917 m 0.317708,0.31770833 V -14.079951 m -0.317708,13.760417 v -13.598958 m 0.317708,-0.161459 h -2.71875 m 2.401042,0.161459 H 9.441661 m -0.322917,-0.161459 v 1.921875 m 0.322917,-1.760416 v 1.760416 M -0.00104767,-0.00182567 V -2.559117 M 0.321869,-0.319534 V -2.397659 M -0.00104767,-2.559117 H 2.082286",
    transform: "matrix(0.75,0,0,0.75,352.2,793.55996)",
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.92187,1055.6823 h 1.76042 v -0.1615",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,0.00183633 H -0.321259 M -3.201467,9.600795 V 8.642461 m 0,-0.161458 V 7.517461 m 0,-0.317708 V 6.39767 m 0,-0.317709 V 5.121628 m 0,-0.161458 V 4.001836 m 0,-0.322916 V 2.720586",
    transform: "matrix(0.75,0,0,0.75,359.28001,784.44003)",
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.83854,1048.4792 v -0.7969",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,0.00183633 H 0.958537 m 0.161458,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.161459,0 H 4.47937 m 0.161458,0 h 0.958334 m 0.322916,0 h 0.958334",
    transform: "matrix(0.75,0,0,0.75,353.16,784.44003)",
    id: "path332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 477.92187,1045.9219 h 0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 217.55859,793.55859 217.67969,783 v 10.55859 z m 0,0",
    id: "path334"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 217.55859,793.55859 V 783 h 0.1211 z m 0,0",
    id: "path335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 217.67969,783.12109 219.35937,783 v 0.12109 z m 0,0",
    id: "path336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 217.67969,783.12109 V 783 h 1.67968 z m 0,0",
    id: "path337"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 219.35937,784.44141 219.48047,783 v 1.44141 z m 0,0",
    id: "path338"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 219.35937,784.44141 V 783 h 0.1211 z m 0,0",
    id: "path339"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.87891,791.76172 1.32031,-0.1211 v 0.1211 z m 0,0",
    id: "path340"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.87891,791.76172 v -0.1211 h 1.32031 z m 0,0",
    id: "path341"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.67969,793.55859 8.51953,-0.23828 v 0.23828 z m 0,0",
    id: "path342"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.67969,793.55859 v -0.23828 h 8.51953 z m 0,0",
    id: "path343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 226.19922,793.55859 0.12109,-1.91797 v 1.91797 z m 0,0",
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 226.19922,793.55859 v -1.91797 h 0.12109 z m 0,0",
    id: "path345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,-0.00182567 H -11.681885 M -0.161052,-0.319534 h -11.359375 m -0.161458,0.31770833 V -14.079951 m 0.161458,13.760417 v -13.598958 m -0.161458,-0.161459 h 2.5625 m -2.401042,0.161459 h 2.239584 m 0.161458,-0.161459 v 1.921875 m -0.161458,-1.760416 v 1.760416 M 4.06667e-4,-0.00182567 V -2.559117 M -0.161052,-0.319534 V -2.397659 M 4.06667e-4,-2.559117 H -1.921468",
    transform: "matrix(0.75,0,0,0.75,226.32001,793.55996)",
    id: "path346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.59896,1055.6823 h -1.76042 v -0.1615",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,0.00183633 H 0.160614 M 3.040822,9.600795 V 8.642461 m 0,-0.161458 V 7.517461 m 0,-0.317708 V 6.39767 m 0,-0.317709 V 5.121628 m 0,-0.161458 V 4.001836 m 0,-0.322916 V 2.720586",
    transform: "matrix(0.75,0,0,0.75,219.36001,784.44003)",
    id: "path348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 295.52083,1048.4792 v -0.7969",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,0.00183633 H -0.797719 m -0.322917,0 h -0.958333 m -0.161459,0 h -0.958333 m -0.161458,0 h -0.958334 m -0.322916,0 h -0.958334 m -0.161458,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,225.36001,784.44003)",
    id: "path350"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.4375,1045.9219 h -0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 388.64062,673.76042 v 94.07813 h -5.92187 v -94.07813 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,4.12e-4 -0.478557,-0.640213 -1.28064,-1.11938 -2.077515,-1.442296 -2.879598,-1.598546 -3.681682,-1.442296 -4.478557,-1.11938 -5.28064,-0.640213 -5.759807,4.12e-4",
    transform: "matrix(0.75,0,0,0.75,291.48001,505.32)",
    id: "path353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-0.00148 0.47937,0.639145 1.281453,1.118312 2.078328,1.441228 2.880412,1.597478 3.682495,1.441228 4.47937,1.118312 5.281453,0.639145 5.76062,-0.00148",
    transform: "matrix(0.75,0,0,0.75,287.16,575.88002)",
    id: "path354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 385.76042,673.76042 v 94.07813",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path355"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g355"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 292.67609,
    y: 527.27277,
    id: "use355"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 27162.371,-15113.496 c 9.009,3.804 13.614,12.813 13.614,27.227 0,4.404 -0.601,8.608 -1.602,12.813 l -5.605,20.82 c -6.407,23.623 -19.019,39.239 -37.637,47.247 -9.209,3.803 -19.62,5.605 -31.231,5.605 h -40.84 c -7.608,0 -11.211,-3.403 -11.211,-10.41 0,-6.807 3.603,-10.41 11.211,-10.41 h 46.445 c 9.009,0 17.618,-2.803 25.626,-8.809 8.008,-6.406 13.012,-14.014 15.215,-23.223 l 5.605,-20.82 c 1.602,-4.805 2.403,-8.809 2.403,-12.012 0,-13.213 -8.809,-20.02 -26.427,-20.02 h -19.218 c -7.007,0 -10.411,-3.403 -10.411,-10.41 0,-6.807 3.404,-10.41 10.411,-10.41 h 24.824 c 12.813,0 23.623,-5.206 32.832,-16.016 4.205,-4.805 7.207,-10.01 8.809,-16.016 0.4,-3.604 0.801,-6.807 0.801,-9.61 0,-14.814 -8.609,-22.422 -25.625,-22.422 h -40.841 c -7.007,0 -10.41,-3.403 -10.41,-10.41 0,-6.807 3.403,-10.41 10.41,-10.41 h 47.247 c 16.016,0 28.028,7.607 36.035,22.422 3.604,6.406 5.606,13.213 5.606,20.02 0,3.803 -0.601,7.207 -1.602,10.41 -6.006,23.023 -17.417,38.037 -34.434,44.844 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path356"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g356"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 292.67609,
    y: 530.26794,
    id: "use356"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 27258.266,-15020.604 c 21.821,0 35.635,-10.611 41.641,-32.032 l 5.606,-20.82 c 1.601,-4.205 2.402,-8.208 2.402,-12.012 0,-13.213 -8.809,-20.02 -26.426,-20.02 h -32.833 l -14.414,52.852 c -0.6,3.203 -0.801,6.006 -0.801,8.008 0,7.007 2.403,12.813 7.208,17.617 4.804,4.405 10.61,6.407 17.617,6.407 z m -5.606,20.82 c -15.014,0 -26.826,-7.607 -35.234,-23.223 -3.804,-6.806 -5.606,-13.813 -5.606,-20.82 0,-2.603 0.2,-5.606 0.801,-8.809 l 16.817,-63.262 c 6.406,-23.423 17.016,-43.243 32.031,-59.259 16.416,-17.617 38.038,-29.629 64.864,-36.035 0.4,0 1.201,0 2.402,0 6.807,0 10.411,3.603 10.411,10.41 0,6.006 -2.403,9.409 -7.207,10.41 -11.812,1.602 -23.624,6.006 -35.235,12.813 -21.421,13.413 -35.035,30.43 -40.84,51.251 h 31.23 c 12.212,0 22.422,3.803 30.43,11.211 8.008,7.607 12.012,17.417 12.012,29.629 0,4.404 -0.6,8.408 -1.601,12.012 l -5.606,20.82 c -7.007,24.624 -19.019,40.44 -36.035,47.247 -9.21,3.803 -20.421,5.605 -33.634,5.605 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path357"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g357"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 292.67609,
    y: 533.14789,
    id: "use357"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 27473.878,-15103.886 -61.66,99.297 c -1.602,3.204 -4.605,4.805 -8.809,4.805 -2.803,0 -5.205,-1.001 -7.207,-3.203 -2.202,-2.002 -3.203,-4.805 -3.203,-8.008 l 7.207,-189.787 c 0,-6.807 3.403,-10.41 10.41,-10.41 7.407,0 11.211,3.804 11.211,11.211 l -6.406,150.548 56.856,-92.891 c 2.002,-3.604 5.005,-5.606 8.809,-5.606 6.806,0 10.61,3.203 11.211,9.61 l 6.406,89.688 77.676,-156.955 c 2.002,-3.603 5.206,-5.605 9.61,-5.605 6.807,0 10.41,3.603 10.41,10.41 0,1.602 -0.4,3.203 -0.801,4.805 l -94.493,190.588 c -2.202,3.803 -5.405,5.605 -9.609,5.605 -7.007,0 -10.41,-3.203 -10.41,-9.609 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path358"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g358"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 292.79901,
    y: 541.67456,
    id: "use358"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 27884.483,-15027.011 c 6.807,0 10.41,3.604 10.41,10.411 0,7.007 -3.603,10.41 -10.41,10.41 h -90.489 c -3.203,0 -5.606,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 l 52.051,-192.991 c 1.001,-5.205 4.205,-8.007 9.61,-8.007 6.807,0 10.41,3.603 10.41,10.41 0,1.201 0,2.202 0,3.203 l -47.246,176.974 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path359"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g359"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 292.79901,
    y: 544.66974,
    id: "use359"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 28044.241,-15111.894 h -57.657 l -22.422,84.883 h 73.672 c 6.807,0 10.411,3.604 10.411,10.411 0,7.007 -3.604,10.41 -10.411,10.41 h -90.489 c -3.203,0 -5.605,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 l 51.251,-190.588 c 1.601,-6.807 6.006,-10.41 13.613,-10.41 h 84.083 c 7.407,0 11.211,3.603 11.211,10.41 0,7.007 -3.804,10.41 -11.211,10.41 h -79.278 l -16.817,64.063 h 52.052 c 6.806,0 10.41,3.604 10.41,10.41 0,7.007 -3.604,10.411 -10.41,10.411 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path360"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g360"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 292.79901,
    y: 547.54968,
    id: "use360"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 28138.333,-15207.188 c 1.602,-6.807 6.006,-10.41 13.614,-10.41 h 65.664 c 11.212,0 20.821,4.804 28.829,14.414 8.408,9.209 12.813,19.219 12.813,30.43 0,2.802 -0.401,5.405 -0.801,8.008 l -28.829,105.704 c -9.609,35.235 -32.632,52.852 -68.868,52.852 h -65.664 c -3.203,0 -5.606,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 z m 18.418,10.41 -44.844,169.767 h 54.454 c 9.009,0 17.617,-2.802 25.625,-8.808 8.008,-6.407 13.213,-14.014 16.016,-23.223 l 28.028,-105.704 c 1.001,-2.603 1.601,-5.206 1.601,-8.008 0,-6.807 -2.803,-12.412 -8.008,-16.817 -4.804,-4.805 -10.81,-7.207 -17.617,-7.207 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 396.16146,722.40105 v 14.07812 h -6.08334 v -14.07812 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 388.64062,913.76042 v 94.07808 h -5.92187 v -94.07808 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,4.12e-4 -0.478557,-0.640213 -1.28064,-1.11938 -2.077515,-1.442296 -2.879598,-1.598546 -3.681682,-1.442296 -4.478557,-1.11938 -5.28064,-0.640213 -5.759807,4.12e-4",
    transform: "matrix(0.75,0,0,0.75,291.48001,685.32)",
    id: "path364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-0.00148 0.47937,0.639145 1.281453,1.118312 2.078328,1.441228 2.880412,1.597478 3.682495,1.441228 4.47937,1.118312 5.281453,0.639145 5.76062,-0.00148",
    transform: "matrix(0.75,0,0,0.75,287.16,755.88002)",
    id: "path365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 385.76042,913.76042 v 94.07808",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path366"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g366"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 292.67609,
    y: 707.27484,
    id: "use366"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 36387.464,-15113.496 c 9.009,3.804 13.613,12.813 13.613,27.227 0,4.404 -0.6,8.608 -1.601,12.813 l -5.606,20.82 c -6.406,23.623 -19.019,39.239 -37.637,47.247 -9.209,3.803 -19.619,5.605 -31.231,5.605 h -40.84 c -7.608,0 -11.211,-3.403 -11.211,-10.41 0,-6.807 3.603,-10.41 11.211,-10.41 h 46.446 c 9.009,0 17.617,-2.803 25.625,-8.809 8.008,-6.406 13.013,-14.014 15.215,-23.223 l 5.605,-20.82 c 1.602,-4.805 2.403,-8.809 2.403,-12.012 0,-13.213 -8.809,-20.02 -26.426,-20.02 h -19.219 c -7.007,0 -10.41,-3.403 -10.41,-10.41 0,-6.807 3.403,-10.41 10.41,-10.41 h 24.824 c 12.813,0 23.624,-5.206 32.833,-16.016 4.204,-4.805 7.207,-10.01 8.808,-16.016 0.401,-3.604 0.801,-6.807 0.801,-9.61 0,-14.814 -8.608,-22.422 -25.625,-22.422 h -40.84 c -7.007,0 -10.411,-3.403 -10.411,-10.41 0,-6.807 3.404,-10.41 10.411,-10.41 h 47.246 c 16.016,0 28.028,7.607 36.036,22.422 3.603,6.406 5.605,13.213 5.605,20.02 0,3.803 -0.6,7.207 -1.601,10.41 -6.006,23.023 -17.418,38.037 -34.434,44.844 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path367"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g367"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 292.67609,
    y: 710.27002,
    id: "use367"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 36483.358,-15020.604 c 21.822,0 35.635,-10.611 41.641,-32.032 l 5.606,-20.82 c 1.601,-4.205 2.402,-8.208 2.402,-12.012 0,-13.213 -8.809,-20.02 -26.426,-20.02 h -32.832 l -14.414,52.852 c -0.601,3.203 -0.801,6.006 -0.801,8.008 0,7.007 2.402,12.813 7.207,17.617 4.805,4.405 10.61,6.407 17.617,6.407 z m -5.605,20.82 c -15.015,0 -26.827,-7.607 -35.235,-23.223 -3.804,-6.806 -5.606,-13.813 -5.606,-20.82 0,-2.603 0.201,-5.606 0.801,-8.809 l 16.817,-63.262 c 6.406,-23.423 17.017,-43.243 32.031,-59.259 16.417,-17.617 38.038,-29.629 64.864,-36.035 0.401,0 1.201,0 2.403,0 6.806,0 10.41,3.603 10.41,10.41 0,6.006 -2.402,9.409 -7.207,10.41 -11.812,1.602 -23.623,6.006 -35.235,12.813 -21.421,13.413 -35.034,30.43 -40.84,51.251 h 31.231 c 12.212,0 22.422,3.803 30.43,11.211 8.008,7.607 12.011,17.417 12.011,29.629 0,4.404 -0.6,8.408 -1.601,12.012 l -5.606,20.82 c -7.007,24.624 -19.018,40.44 -36.035,47.247 -9.209,3.803 -20.42,5.605 -33.633,5.605 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path368"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g368"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 292.67609,
    y: 713.15002,
    id: "use368"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 36698.971,-15103.886 -61.661,99.297 c -1.602,3.204 -4.605,4.805 -8.809,4.805 -2.803,0 -5.205,-1.001 -7.207,-3.203 -2.202,-2.002 -3.203,-4.805 -3.203,-8.008 l 7.207,-189.787 c 0,-6.807 3.403,-10.41 10.41,-10.41 7.408,0 11.211,3.804 11.211,11.211 l -6.406,150.548 56.856,-92.891 c 2.002,-3.604 5.005,-5.606 8.809,-5.606 6.807,0 10.61,3.203 11.211,9.61 l 6.406,89.688 77.677,-156.955 c 2.002,-3.603 5.205,-5.605 9.609,-5.605 6.807,0 10.41,3.603 10.41,10.41 0,1.602 -0.4,3.203 -0.8,4.805 l -94.493,190.588 c -2.203,3.803 -5.406,5.605 -9.61,5.605 -7.007,0 -10.41,-3.203 -10.41,-9.609 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path369"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g369"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 292.79901,
    y: 721.67279,
    id: "use369"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 37109.375,-15027.011 c 6.807,0 10.41,3.604 10.41,10.411 0,7.007 -3.603,10.41 -10.41,10.41 h -90.489 c -3.203,0 -5.606,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 l 52.051,-192.991 c 1.001,-5.205 4.205,-8.007 9.61,-8.007 6.807,0 10.41,3.603 10.41,10.41 0,1.201 0,2.202 0,3.203 l -47.246,176.974 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path370"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g370"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 292.79901,
    y: 724.66797,
    id: "use370"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 37269.333,-15111.894 h -57.657 l -22.422,84.883 h 73.673 c 6.806,0 10.41,3.604 10.41,10.411 0,7.007 -3.604,10.41 -10.41,10.41 h -90.49 c -3.203,0 -5.605,-1.001 -7.207,-3.203 -1.601,-2.002 -2.002,-4.405 -0.801,-7.207 l 51.251,-190.588 c 1.602,-6.807 6.006,-10.41 13.613,-10.41 h 84.083 c 7.408,0 11.211,3.603 11.211,10.41 0,7.007 -3.803,10.41 -11.211,10.41 h -79.278 l -16.816,64.063 h 52.051 c 6.807,0 10.41,3.604 10.41,10.41 0,7.007 -3.603,10.411 -10.41,10.411 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path371"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g371"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 292.79901,
    y: 727.54797,
    id: "use371"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 37363.225,-15207.188 c 1.602,-6.807 6.006,-10.41 13.614,-10.41 h 65.665 c 11.211,0 20.82,4.804 28.828,14.414 8.408,9.209 12.813,19.219 12.813,30.43 0,2.802 -0.401,5.405 -0.801,8.008 l -28.829,105.704 c -9.609,35.235 -32.632,52.852 -68.868,52.852 h -65.664 c -3.203,0 -5.606,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 z m 18.419,10.41 -44.845,169.767 h 54.454 c 9.009,0 17.617,-2.802 25.625,-8.808 8.008,-6.407 13.213,-14.014 16.016,-23.223 l 28.028,-105.704 c 1.001,-2.603 1.601,-5.206 1.601,-8.008 0,-6.807 -2.802,-12.412 -8.008,-16.817 -4.804,-4.805 -10.81,-7.207 -17.617,-7.207 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 396.16146,962.40105 v 14.07812 h -6.08334 v -14.07812 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.47917,999.6823 h -4.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,999.83855 -0.64062,-0.79688 -0.80209,-0.64062 -0.95833,-0.32292 -0.96354,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,997.92188 h -7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,997.92188 -0.95834,0.15625 -0.95833,0.32292 -0.80208,0.64062 -0.64063,0.79688 -0.31771,0.96355 -0.16146,0.9583",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,1001.7604 v 23.5209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path378"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.64062,1025.2813 0.16146,0.9583 0.31771,0.9583 0.64063,0.8021 0.80208,0.6406 0.95833,0.3177 0.95834,0.1615",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path379"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,1029.2813 h 7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path380"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,1029.1198 0.96354,-0.1615 0.95833,-0.3177 0.80209,-0.6406 0.64062,-0.8021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,1027.3594 h 4.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.64062,1027.1979 0.95834,0.4844 0.96354,0.1562",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.5625,1027.8385 2.23958,0.6407 2.39584,0.3229 2.23958,0.3177 h 2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,1029.1198 h 2.40104 l 2.23959,-0.3177 2.40104,-0.3229 2.23958,-0.6407",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.28125,1027.8385 1.91667,-0.4791 1.76041,-0.7969 1.76042,-0.9635 1.76042,-0.9584",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.47917,1024.6406 1.59895,-1.1198 1.28125,-1.2812 1.28125,-1.4375 1.1198,-1.6042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 353.59896,1019.1979 0.64062,-1.276 0.47917,-1.4427 0.32292,-1.4375 0.15625,-1.4427",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 355.19792,1013.599 -0.15625,-1.4375 -0.32292,-1.4427 -0.47917,-1.4375 -0.64062,-1.2813",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 353.76042,1008 -1.1198,-1.599 -1.28125,-1.4427 -1.28125,-1.276 -1.59895,-1.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.47917,1002.401 -1.76042,-0.9635 -1.76042,-0.9583 -1.76041,-0.7969 -1.91667,-0.48438",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.11979,999.19792 -2.23958,-0.63542 -2.40104,-0.32291 -2.23959,-0.31771 h -2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,997.92188 h -2.40104 l -2.23958,0.31771 -2.39584,0.32291 -2.23958,0.63542",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.5625,999.19792 -0.96354,0.16146 -0.95834,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,1020.4792 0.64062,0.4791 0.63542,0.323",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 317.4375,1021.4375 1.44271,0.8021 1.59896,0.8021 1.59895,0.6406 1.60417,0.4792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.52083,1024.1615 2.07813,0.4791 2.08333,0.3177 2.07813,0.323 h 2.07812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,1025.2813 h 2.08333 l 2.07813,-0.323 2.07812,-0.3177 2.08334,-0.4791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.16146,1024.1615 1.59896,-0.4792 1.59895,-0.6406 1.59896,-0.8021 1.44271,-0.8021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path399"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 346.23958,1021.2813 1.28125,-0.8021 2.07813,-2.0782 0.80208,-1.2812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.40104,1017.1198 0.31771,-0.8021 0.32292,-0.7969 0.3177,-0.9583 v -0.9635",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path401"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 351.35937,1013.599 v -0.9584 l -0.3177,-0.9583 -0.32292,-0.8021 -0.31771,-0.8021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.40104,1010.0781 -0.80208,-1.276 -1.11979,-1.1198 -0.95834,-0.9635 -1.28125,-0.7969",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 346.40104,1005.599 -1.44271,-0.7969 -1.59896,-0.8021 -1.59895,-0.6406 -1.59896,-0.4792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path404"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.16146,1002.8802 -2.08334,-0.4792 -2.07812,-0.3229 -2.07813,-0.3177 h -2.08333",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path405"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,1001.7604 h -2.07812 l -2.07813,0.3177 -2.08333,0.3229 -2.07813,0.4792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.68229,1002.8802 -1.60417,0.4792 -1.59895,0.6406 -1.59896,0.8021 -1.44271,0.7969",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 317.4375,1005.9219 -0.63542,0.3177 -0.64062,0.4792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,1028 0.64062,-0.1615 0.80209,-0.1562 0.47916,-0.4844 0.47917,-0.6354 0.32292,-1.2812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,1028 h -7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.76042,1025.2813 0.16145,0.6406 0.15625,0.6406 0.48438,0.6354 0.63542,0.4844 0.64062,0.1562 0.64063,0.1615",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.59896,1025.2813 v -23.5209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,999.04167 -0.64063,0.15625 -0.64062,0.16146 -0.63542,0.47917 -0.48438,0.47915 -0.15625,0.8021 -0.16145,0.6406",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path413"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,999.04167 h 7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.04167,1001.7604 -0.16146,-0.6406 -0.16146,-0.8021 -0.95833,-0.95832 -0.80209,-0.16146 -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.04167,1001.7604 v 23.5209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,1001.7604 v -0.4791 L 316,1000.8021 l -0.16146,-0.4844 -0.15625,-0.47915",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,1001.7604 v 23.5209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,1027.1979 0.15625,-0.4791 0.32292,-0.9584 v -0.4791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,2.08667e-4 -1.278951,0.958542 -2.242493,2.239792 -3.039368,3.6825 -3.518535,5.12 l -0.161458,1.598959 0.161458,1.598958 0.479167,1.442708 0.796875,1.4375 0.963542,1.28125 1.28124967,0.958334",
    transform: "matrix(0.75,0,0,0.75,260.75999,755.16)",
    id: "path420"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,2.08667e-4 0.638326,-0.16125 1.117493,-0.640416 1.278951,-1.281041 1.117493,-1.921666 0.638326,-2.400833 -0.00229867,-2.562291 -0.637715,-2.400833 l -0.484375,0.479167 -0.15625,0.640625 0.15625,0.640625 0.484375,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,231.24,761.16)",
    id: "path421"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,979.6823 h -92.80208 v -1.28125 h 94.08333 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path422"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 355.35937,777.92188 v 1.27604 h -54.8802 v -1.27604 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 394.5625,1042.401 v 5.2813 h -1.28125 v -6.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,986.23959 v -6.55729 m 1.28125,0 v 6.55729",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 427.83854,764.31771 V 591.83855 h 43.04167 v 172.47916 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path426"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,723.19792 -1.28125,0.32292 -0.63542,0.47916 -0.48438,0.47917 -0.15625,0.80208 -0.16145,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path427"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,723.19792 h 25.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,725.92188 -0.16146,-0.64063 -0.15625,-0.80208 -0.48437,-0.47917 -0.47917,-0.47916 -0.79687,-0.16146 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 461.11979,725.92188 V 759.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path430"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 458.40104,762.40105 0.64063,-0.16146 0.79687,-0.16146 0.47917,-0.47917 0.48437,-0.64062 0.15625,-0.64063 0.16146,-0.63541",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 458.40104,762.40105 H 432.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 429.76042,759.6823 0.16145,0.63541 0.15625,0.64063 0.48438,0.64062 0.63542,0.47917 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path433"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 429.76042,759.6823 V 725.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.001694 -1.121887,0.157944 -2.08022,0.642319 -2.882304,1.277736 -3.51772,2.241277 -3.840637,3.361069 v 0.958333 l 0.322917,1.119792 0.635416,0.958333 0.802084,0.640625 0.958333,0.484375 1.11979167,0.15625 L 1.117696,7.522527 2.081238,7.038152 2.878113,6.397527 3.518738,5.439194 3.841655,4.319402 V 3.361069 L 3.518738,2.241277 2.878113,1.277736 2.081238,0.642319 1.117696,0.157944 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,335.40001,554.27998)",
    id: "path435"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 444.31771,745.59896 449.92187,740 m 0,5.59896 L 444.31771,740",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00168333 -0.80249,0.159775 -1.760823,1.118108 -1.922282,1.920192 -1.760823,2.722275 -0.80249,3.680608 -4.06667e-4,3.842067 0.801677,3.680608 1.76001,2.722275 1.921468,1.920192 1.76001,1.118108 0.801677,0.159775 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,349.67999,555.72001)",
    id: "path437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,680.16146 -0.64063,0.15625 -0.64062,0.16146 -0.63542,0.47917 -0.48438,0.47916 -0.15625,0.80209 -0.16145,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,680 h 25.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,682.88021 -0.16146,-0.64062 -0.15625,-0.80209 -0.48437,-0.47916 -0.47917,-0.47917 -0.79687,-0.16146 -0.64063,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path440"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,682.88021 v 33.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 458.40104,719.19792 0.64063,-0.15625 0.79687,-0.16146 0.47917,-0.47916 0.48437,-0.64063 0.15625,-0.64062 0.16146,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 458.40104,719.19792 H 432.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 429.76042,716.47917 0.16145,0.64063 0.15625,0.64062 0.48438,0.64063 0.63542,0.47916 0.64062,0.16146 0.64063,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 429.76042,716.47917 V 682.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00148 -1.121887,0.159978 -2.08022,0.639145 -2.882304,1.27977 -3.51772,2.238103 -3.840637,3.357895 v 0.963542 l 0.322917,1.119791 0.635416,0.958334 0.802084,0.640625 0.958333,0.479166 1.11979167,0.161459 L 1.117696,7.519353 2.081238,7.040187 2.878113,6.399562 3.518738,5.441228 3.841655,4.321437 V 3.357895 L 3.518738,2.238103 2.878113,1.27977 2.081238,0.639145 1.117696,0.159978 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,335.40001,521.88002)",
    id: "path446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.31771,702.40105 5.60416,-5.44271 m 0,5.44271 -5.60416,-5.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,4.12e-4 -0.80249,0.16187 -1.760823,1.120204 -1.922282,1.922287 -1.760823,2.719162 -0.80249,3.677495 -4.06667e-4,3.838954 0.801677,3.677495 1.76001,2.719162 1.921468,1.922287 1.76001,1.120204 0.801677,0.16187 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,349.67999,523.32)",
    id: "path448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,636.95834 -1.28125,0.32291 -0.63542,0.47917 -0.48438,0.47917 -0.15625,0.80208 -0.16145,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,636.95834 h 25.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path450"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,639.6823 -0.16146,-0.64063 -0.15625,-0.80208 -0.48437,-0.47917 -0.47917,-0.47917 -0.79687,-0.16145 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path451"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,639.6823 v 33.7552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 458.40104,676.16146 459.04167,676 l 0.79687,-0.16145 0.47917,-0.47917 0.48437,-0.64063 0.15625,-0.64062 0.16146,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 458.40104,676.16146 H 432.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 429.76042,673.4375 0.16145,0.64063 0.15625,0.64062 0.48438,0.64063 0.63542,0.47917 1.28125,0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path455"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 429.76042,673.4375 V 639.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,6.15333e-4 -1.121887,0.162074 -2.08022,0.64124 -2.882304,1.281865 -3.51772,2.240199 -3.840637,3.35999 v 0.958334 l 0.322917,1.119791 0.635416,0.963542 0.802084,0.640625 0.958333,0.479167 1.11979167,0.15625 L 1.117696,7.521449 2.081238,7.042282 2.878113,6.401657 3.518738,5.438115 3.841655,4.318324 V 3.35999 L 3.518738,2.240199 2.878113,1.281865 2.081238,0.64124 1.117696,0.162074 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,335.40001,489.48001)",
    id: "path457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.31771,659.35938 5.60416,-5.59896 m 0,5.59896 -5.60416,-5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,0.00250733 -0.80249,0.158757 -1.281657,0.637924 -1.760823,1.122299 -1.922282,1.919174 -1.760823,2.721257 -0.80249,3.679591 -4.06667e-4,3.841049 0.801677,3.679591 1.76001,2.721257 1.921468,1.919174 1.76001,1.122299 1.280843,0.637924 0.801677,0.158757 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,349.67999,490.91999)",
    id: "path459"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,593.76042 -0.64063,0.16146 -0.64062,0.15625 -0.63542,0.48437 -0.48438,0.47917 -0.15625,0.79688 -0.16145,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path460"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.47917,593.76042 h 25.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,596.47917 -0.16146,-0.64062 -0.15625,-0.79688 -0.48437,-0.47917 -0.47917,-0.48437 -0.79687,-0.15625 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,596.47917 v 33.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 458.40104,632.95834 0.64063,-0.15625 0.79687,-0.16146 0.47917,-0.47917 0.48437,-0.64062 0.15625,-0.64063 0.16146,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 458.40104,632.95834 H 432.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path465"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 429.76042,630.23959 0.16145,0.64062 0.15625,0.64063 0.48438,0.64062 0.63542,0.47917 0.64062,0.16146 0.64063,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 429.76042,630.23959 V 596.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00101233 -1.121887,0.160446 -2.08022,0.639613 -2.882304,1.280238 -3.51772,2.238571 -3.840637,3.358363 v 0.963541 l 0.322917,1.119792 0.635416,0.958333 0.802084,0.640625 0.958333,0.479167 1.11979167,0.161458 L 1.117696,7.519821 2.081238,7.040654 2.878113,6.400029 3.518738,5.441696 3.841655,4.321904 V 3.358363 L 3.518738,2.238571 2.878113,1.280238 2.081238,0.639613 1.117696,0.160446 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,335.40001,457.19998)",
    id: "path468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.31771,616.16146 5.60416,-5.44271 m 0,5.44271 -5.60416,-5.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path469"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,8.18667e-4 -0.80249,0.162277 -1.760823,1.12061 -1.922282,1.917485 -1.760823,2.719569 -0.80249,3.677902 -4.06667e-4,3.83936 0.801677,3.677902 1.76001,2.719569 1.921468,1.917485 1.76001,1.12061 0.801677,0.162277 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,349.67999,458.64001)",
    id: "path470"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,1041.1198 h 56.15625 v 1.2812 h -54.875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path471"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,-1.98e-4 -0.15625,-4.317708 -0.479167,-4.322917 -0.963541,-4.317708 -1.119792,-4.161459 -1.598958,-4.161458 -1.760417,-4 -2.239583,-3.838542 -2.401042,-3.520833 -2.71875,-3.359375 -3.041667,-3.197917 -3.359375,-3.041666 -3.359375,-2.5625 -3.677083,-2.395834 -3.84375,-2.083333 -4,-1.760417 -4.15625,-1.4375 -4.161458,-1.119791 -4.322917,-0.802084 -4.479167,-0.317708 -4.317708,-0.161458",
    transform: "matrix(0.75,0,0,0.75,337.08,780.83999)",
    id: "path472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.47917,931.19792 h -4.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,931.35938 -0.64062,-0.79688 -0.80209,-0.64062 -0.95833,-0.32292 -0.96354,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,929.28125 h -7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path475"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,929.4375 -0.95834,0.16146 -0.95833,0.32292 -0.80208,0.64062 -0.64063,0.79688 -0.31771,0.95833 -0.16146,0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path476"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,933.28125 v 23.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.64062,956.80209 0.16146,0.95833 0.31771,0.95833 0.64063,0.80209 0.80208,0.64062 0.95833,0.31771 0.95834,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,960.64063 h 7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,960.64063 0.96354,-0.16146 0.95833,-0.31771 0.80209,-0.64062 0.64062,-0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path480"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,958.71875 h 4.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path481"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.64062,958.5625 0.95834,0.47917 0.96354,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path482"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.5625,959.35938 2.23958,0.64062 2.39584,0.31771 2.23958,0.32292 h 2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path483"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,960.64063 h 2.40104 l 2.23959,-0.32292 2.40104,-0.31771 2.23958,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.28125,959.19792 1.91667,-0.47917 1.76041,-0.79687 1.76042,-0.96354 L 348.47917,956",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path485"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.47917,956 1.59895,-1.11979 1.28125,-1.28125 1.28125,-1.4375 1.1198,-1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 353.59896,950.5625 0.64062,-1.28125 0.47917,-1.4427 0.32292,-1.4375 0.15625,-1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 355.19792,944.95834 -0.15625,-1.4375 -0.32292,-1.44271 -0.47917,-1.4375 -0.64062,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 353.76042,939.35938 -1.1198,-1.59896 -1.28125,-1.44271 -1.28125,-1.27604 -1.59895,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.47917,933.92188 -1.76042,-0.96354 -1.76042,-0.95834 -1.76041,-0.80208 -1.91667,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path490"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.11979,930.71875 -2.23958,-0.64062 -2.40104,-0.31771 -2.23959,-0.32292 h -2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,929.4375 h -2.40104 l -2.23958,0.32292 -2.39584,0.31771 -2.23958,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.5625,930.71875 -0.96354,0.16146 -0.95834,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,951.83855 0.64062,0.47916 0.63542,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 317.4375,952.80209 1.44271,0.79687 1.59896,0.80209 1.59895,0.64062 1.60417,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.52083,955.6823 2.07813,0.47916 2.08333,0.31771 2.07813,0.32292 h 2.07812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,956.80209 h 2.08333 L 336,956.47917 l 2.07812,-0.31771 2.08334,-0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.16146,955.52084 1.59896,-0.47917 1.59895,-0.64062 1.59896,-0.80209 1.44271,-0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 346.23958,952.64063 1.28125,-0.80208 2.07813,-2.07813 0.80208,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.40104,948.47917 0.31771,-0.79687 0.32292,-0.80209 0.3177,-0.95833 v -0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 351.35937,944.95834 V 944 l -0.3177,-0.95833 -0.32292,-0.80208 -0.31771,-0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.40104,941.4375 -0.80208,-1.27604 -1.11979,-1.11979 -0.95834,-0.96354 -1.28125,-0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path502"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 346.40104,937.1198 -1.44271,-0.80209 -1.59896,-0.79687 -1.59895,-0.64063 -1.59896,-0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.16146,934.40105 -2.08334,-0.47917 -2.07812,-0.32292 -2.07813,-0.31771 h -2.08333",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,933.28125 h -2.07812 l -2.07813,0.31771 -2.08333,0.32292 -2.07813,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.68229,934.40105 -1.60417,0.47916 -1.59895,0.64063 -1.59896,0.79687 -1.44271,0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 317.4375,937.28125 -0.63542,0.31771 -0.64062,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,959.52084 0.64062,-0.16146 0.80209,-0.16146 0.47916,-0.47917 0.47917,-0.64062 0.16146,-0.64063 0.16146,-0.63541",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,959.52084 h -7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path509"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.76042,956.80209 0.16145,0.63541 0.15625,0.64063 0.48438,0.64062 0.63542,0.47917 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path510"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 301.59896,956.80209 V 933.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path511"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,930.5625 -0.64063,0.15625 -0.64062,0.16146 -0.63542,0.47917 -0.48438,0.47917 -0.15625,0.80208 -0.16145,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,930.5625 h 7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.04167,933.28125 -0.16146,-0.64062 -0.16146,-0.80208 -0.95833,-0.95834 -0.80209,-0.16146 -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path514"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.04167,933.28125 v 23.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,933.28125 v -0.47916 L 316,932.31771 l -0.16146,-0.47916 -0.15625,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,933.28125 v 23.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,958.71875 0.15625,-0.47916 0.32292,-0.95834 v -0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,-4.01333e-4 -1.278951,0.957932 l -0.963542,1.28125 -0.796875,1.442708 -0.479167,1.4375 -0.161458,1.598959 0.161458,1.604166 0.479167,1.4375 0.796875,1.4375 0.963542,1.28125 1.28124967,0.963542",
    transform: "matrix(0.75,0,0,0.75,260.75999,703.67999)",
    id: "path519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-4.01333e-4 0.638326,-0.16186 1.117493,-0.641026 1.278951,-1.281651 1.117493,-1.922276 0.638326,-2.401443 l -0.64062467,-0.15625 -0.63541633,0.15625 -0.484375,0.479167 -0.15625,0.640625 0.15625,0.640625 0.484375,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,231.24,709.67999)",
    id: "path520"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,911.19792 h -92.80208 v -1.27604 h 94.08333 v 1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 394.5625,973.76042 v 5.28125 h -1.28125 v -6.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path522"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,917.76042 v -6.5625 m 1.28125,0 v 6.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,972.64063 h 56.15625 v 1.11979 h -54.875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,6.15333e-4 -0.158752,-4.322301 -0.637919,-8.64001 l -0.963541,-4.317708 -1.119792,-4.161458 -1.598958,-4.161459 -1.760417,-4 -2.239583,-3.838541 -2.401042,-3.520834 -2.71875,-3.359375 -3.041667,-3.203125 -3.359375,-3.036458 -3.359375,-2.5625 -3.677083,-2.401042 -3.84375,-2.078125 -4,-1.760416 -4.15625,-1.4375 -4.161458,-1.119792 -4.322917,-0.802083 -4.479167,-0.317709 -4.317708,-0.161458",
    transform: "matrix(0.75,0,0,0.75,337.08,729.48001)",
    id: "path525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.47917,862.07813 h -4.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,862.07813 -0.64062,-0.79688 -0.80209,-0.64062 -0.95833,-0.32292 -0.96354,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path527"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,860.16146 h -7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,860.16146 -0.95834,0.15625 -0.95833,0.32292 -0.80208,0.64062 -0.64063,0.79688 -0.31771,0.96354 L 300.64062,864",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,864 v 23.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path530"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.64062,887.6823 0.16146,0.95833 0.31771,0.95833 0.64063,0.80209 0.80208,0.64062 0.95833,0.31771 0.95834,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,891.52084 h 7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,891.52084 0.96354,-0.16146 0.95833,-0.31771 0.80209,-0.64062 0.64062,-0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,889.59896 h 4.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.64062,889.4375 0.95834,0.48438 0.96354,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.5625,890.07813 2.23958,0.64062 2.39584,0.32292 2.23958,0.31771 h 2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,891.35938 h 2.40104 l 2.23959,-0.31771 2.40104,-0.32292 2.23958,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.28125,890.07813 1.91667,-0.47917 1.76041,-0.79687 1.76042,-0.96354 1.76042,-0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.47917,886.88021 1.59895,-1.11979 1.28125,-1.28125 1.28125,-1.4375 1.1198,-1.60417",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path539"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 353.59896,881.4375 0.64062,-1.27604 0.47917,-1.44271 0.32292,-1.4375 0.15625,-1.4427",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 355.19792,875.83855 -0.15625,-1.4375 -0.32292,-1.44271 -0.47917,-1.4375 -0.64062,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path541"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 353.76042,870.23959 -1.1198,-1.59896 -1.28125,-1.44271 -1.28125,-1.27604 -1.59895,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.47917,864.80209 -1.76042,-0.96354 -1.76042,-0.95834 -1.76041,-0.80208 -1.91667,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path543"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.11979,861.59896 -2.23958,-0.64062 -2.40104,-0.31771 -2.23959,-0.32292 h -2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,860.31771 h -2.40104 l -2.23958,0.32292 -2.39584,0.31771 -2.23958,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.5625,861.59896 -0.96354,0.16146 -0.95834,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,882.71875 0.64062,0.47917 0.63542,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 317.4375,883.6823 1.44271,0.79687 1.59896,0.80208 1.59895,0.64063 1.60417,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.52083,886.40105 2.07813,0.47916 2.08333,0.31771 2.07813,0.32292 h 2.07812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path549"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,887.52084 h 2.08333 L 336,887.19792 l 2.07812,-0.31771 2.08334,-0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.16146,886.40105 1.59896,-0.47917 1.59895,-0.64063 1.59896,-0.80208 1.44271,-0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 346.23958,883.52084 1.28125,-0.80209 2.07813,-2.07812 0.80208,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.40104,879.35938 0.31771,-0.79688 0.32292,-0.80208 0.3177,-0.95833 v -0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 351.35937,875.83855 v -0.95834 l -0.3177,-0.95833 -0.32292,-0.80208 -0.31771,-0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.40104,872.31771 -0.80208,-1.27604 -1.11979,-1.11979 -0.95834,-0.96354 -1.28125,-0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 346.40104,868 -1.44271,-0.80208 -1.59896,-0.79687 -1.59895,-0.64063 -1.59896,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.16146,865.28125 -2.08334,-0.47916 -2.07812,-0.32292 -2.07813,-0.31771 h -2.08333",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 331.83854,864.16146 h -2.07812 l -2.07813,0.31771 -2.08333,0.32292 -2.07813,0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 323.68229,865.28125 -1.60417,0.47917 -1.59895,0.64063 -1.59896,0.79687 L 317.4375,868",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 317.4375,868.16146 -0.63542,0.31771 -0.64062,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,890.40105 0.64062,-0.16146 0.80209,-0.16146 0.47916,-0.47917 0.47917,-0.64062 0.16146,-0.64063 0.16146,-0.63541",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 312.31771,890.40105 h -7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.76042,887.6823 0.16145,0.63541 0.15625,0.64063 0.48438,0.64062 0.63542,0.47917 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 301.59896,887.6823 V 864",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,861.28125 -0.64063,0.15625 -0.64062,0.16146 -0.63542,0.47917 -0.48438,0.48437 -0.15625,0.79688 L 301.76042,864",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.47917,861.28125 h 7.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.04167,864 -0.16146,-0.64062 -0.16146,-0.79688 -0.47917,-0.48437 -0.47916,-0.47917 -0.80209,-0.16146 -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.04167,864 v 23.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,864 v -0.47916 l -0.32292,-0.95834 -0.15625,-0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path569"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.16146,864 v 23.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path570"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 315.68229,889.59896 0.15625,-0.47916 0.32292,-0.95834 v -0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00229867,-1.98e-4 -1.28124967,0.958333 -0.963542,1.28125 -0.796875,1.442709 -0.479167,1.4375 -0.161458,1.598958 0.161458,1.598958 0.479167,1.442709 0.796875,1.4375 0.963542,1.28125 1.28124967,0.963541",
    transform: "matrix(0.75,0,0,0.75,260.75999,651.83999)",
    id: "path572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-1.98e-4 0.638326,-0.161656 1.117493,-0.640823 1.278951,-1.281448 1.117493,-1.922073 0.638326,-2.40124 -0.00229867,-2.55749 -0.637715,-2.40124 l -0.484375,0.479167 -0.15625,0.640625 0.15625,0.640625 0.484375,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,231.24,657.83999)",
    id: "path573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,842.07813 -92.80208,-0.15625 v -1.28125 l 94.08333,0.16146 v 1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path574"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 394.5625,904.64063 v 5.28125 h -1.28125 v -6.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,848.47917 v -6.40104 m 1.28125,0 v 6.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 393.28125,903.35938 h 56.15625 v 1.28125 h -54.875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,-6.04667e-4 -0.158752,-4.318313 -0.637919,-8.64123 l -0.963541,-4.317708 -1.119792,-4.161458 -1.598958,-4.161459 -1.760417,-4 -2.239583,-3.838541 -2.401042,-3.520834 -2.71875,-3.359375 -3.041667,-3.197916 -3.359375,-3.041667 -3.359375,-2.557292 -3.677083,-2.401041 -3.84375,-2.083334 -4,-1.760416 -4.15625,-1.4375 -4.161458,-1.119792 -4.322917,-0.802083 -4.479167,-0.317709 -4.317708,-0.161458",
    transform: "matrix(0.75,0,0,0.75,337.08,677.51999)",
    id: "path578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 306.5625,799.6823 v 24.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 321.92187,808.31771 -3.52083,-5.4375 -4.32292,-5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path580"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 319.52083,809.76042 -2.40104,-4 -2.88021,-3.83854 -3.35937,-3.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path581"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,793.59896 v 36.64063 h 14.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path582"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 306.5625,824.16146 8.15625,2.07813",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 319.68229,813.92188 320,812.95834 320.16146,812 320,811.04167 l -0.31771,-0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path584"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 321.76042,815.52084 0.47916,-1.11979 0.32292,-1.1198 0.15625,-1.28125 -0.15625,-1.28125 -0.32292,-1.11979 -0.47916,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.71875,826.23959 v 4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.07812,826.07813 4.32292,-5.11979 3.52083,-5.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path587"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001251,-0.00188667 -0.796875,0.16145867 -0.484375,0.479166 -0.479167,0.479167 -0.15625,0.802083 0.15625,0.802084 0.479167,0.479166 0.484375,0.479167 0.796875,0.161458 L 0.800832,3.680405 1.759166,2.722072 1.920624,1.919988 1.759166,1.117905 0.800832,0.159572 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,236.04,607.56001)",
    id: "path588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.88021,825.4375 3.35937,-3.51562 2.88021,-3.68229 2.40104,-4.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path589"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,793.59896 h 14.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path590"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 306.5625,799.6823 8.15625,-2.08334 v -4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path591"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 355.35937,715.19792 v 1.28125 h -54.8802 v -1.28125 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path592"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 306.5625,736.95834 V 761.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path593"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 321.92187,745.59896 -3.52083,-5.4375 -4.32292,-5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 319.52083,747.04167 -2.40104,-4 -2.88021,-3.84375 -3.35937,-3.51562",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,730.88021 v 36.64063 h 14.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 306.5625,761.4375 8.15625,2.08334",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 319.68229,751.19792 320,750.23959 320.16146,749.28125 320,748.31771 l -0.31771,-0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 321.76042,752.80209 0.47916,-1.11979 0.32292,-1.1198 0.15625,-1.28125 L 322.5625,748 l -0.32292,-1.11979 -0.47916,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.71875,763.52084 v 4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.07812,763.35938 4.32292,-5.11979 3.52083,-5.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path601"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,-6.04667e-4 -0.798126,0.160854 -1.282501,0.64002 l -0.479167,0.479167 -0.15625,0.802083 0.15625,0.796875 0.479167,0.484375 0.484375,0.479167 0.796875,0.15625 L 0.800832,3.681687 1.279999,3.20252 1.759166,2.718145 1.920624,1.92127 1.759166,1.119187 0.800832,0.160854 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,236.04,560.51999)",
    id: "path602"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.88021,762.71875 3.35937,-3.52083 2.88021,-3.83854 2.40104,-4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path603"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.47917,730.88021 h 14.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path604"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 306.5625,736.95834 8.15625,-2.07813 v -4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path605"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/План _Туалет.4716ce83fe71eeddae5a65c04563efc7.svg";
export { ForwardRef as ReactComponent };